module.exports = __webpack_public_path__ + "static/media/subGoogle1.f2e964b1.png";